import { render } from "./MenuHeader.vue?vue&type=template&id=ef7f8f1c"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__